import React, { useEffect, useState } from "react";
import Processing from "./processing";
import Success from "./success";
import { apis, post } from "../../../../../../Utils/axios";
import { useLocation } from "react-router-dom";
import { Toast } from "../../../../../../Components";
import BookingFailed from "./failed";
import BookingPending from "./pending";

const BOOKING_TIMEOUT_MS = 5 * 60 * 1000;
const getFailedBookingState = (error) => {
	const responseData = error?.response?.data || {};
	const responseHeaders = error?.response?.headers || {};
	const requestHeaders = error?.config?.headers || {};

	const traceId =
		responseHeaders["x-trace-id"] ||
		responseHeaders["X-Trace-Id"] ||
		requestHeaders["X-Trace-Id"] ||
		requestHeaders["x-trace-id"];

	const flowId =
		responseHeaders["x-flow-id"] ||
		responseHeaders["X-Flow-Id"] ||
		requestHeaders["X-Flow-Id"] ||
		requestHeaders["x-flow-id"];

	return {
		status: "FAILED",
		bookingId: responseData.bookingId || responseData.booking?.bookingId || responseData.booking?.id,
		error: responseData.error || error?.message || "Something went wrong while confirming your booking.",
		traceId,
		flowId,
	};
};

function ConfirmBooking() {
	const LOCATION = useLocation();
	const { selectedFlightOptionKey, logo, name, code, approvalId, requestId, customFields, costCenterId, passengers, paymentMode, date, from, to, airline, flightNumber, flightType, flowId } = LOCATION.state || {};

	const [Booking, setBooking] = useState();

	useEffect(() => {
		if (selectedFlightOptionKey) bookFlight();
	}, []);

	const bookFlight = () => {
		setBooking();
		post(
			apis.bookFlight,
			{
				requestId,
				approvalId,
				customFields,
				costCenterId,
				passengers,
				paymentMode,
				selectedFlightOptionKey,
				date,
				from,
				to,
				airline,
				flightNumber,
				flightType,
			},
			(r, e) => {
				//clear the location state
				window.history.replaceState({}, "", window.location.pathname);
				if (r?.booking) {
					setBooking(r.booking);
					//Clear the location state
				} else if (e) {
					Toast.handleError(e);
					setBooking(getFailedBookingState(e));
				}
			},
			{
				timeout: BOOKING_TIMEOUT_MS,
				headers: flowId
					? {
							"X-Flow-Id": flowId,
					  }
					: undefined,
			}
		);
	};

	if (Booking?.status === "BOOKED") return <Success booking={Booking} />;
	if (Booking?.status === "FAILED") return <BookingFailed booking={Booking} />;
	if (Booking?.status === "PENDING") return <BookingPending booking={Booking} />;
	return <Processing flight={{ logo, name, code }} />;
}

export default ConfirmBooking;
